import React from 'react';
import { Container, Typography } from '@mui/material';
import UserLotsTable from '../Components/UserLotsTable';

const UserLotsPage = () => {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>
      Количество лотов
      </Typography>
      <UserLotsTable />
    </Container>
  );
};

export default UserLotsPage;
